import { FC } from "react";
import { useLocation } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import {
  FullBleedSection,
  MaxContentSection,
  BackNavArrowCta,
} from "~/components";
import { useMetaByPathConfig } from "./hooks";
import { Phase } from "./Phase";
import { ProgressBar } from "./ProgressBar";
import { useNav } from "./useNav";

export const Nav: FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { goToPrevious } = useNav();
  const { metaByPath } = useMetaByPathConfig();

  if (metaByPath[currentPath].excludeNav) {
    return null;
  }

  return (
    <FullBleedSection bg="th.cream1" w="full">
      <MaxContentSection
        align="center"
        h={{ base: "3.625rem", md: 22 }}
        justify="center"
        maxW="160rem"
        overflow="hidden"
        position="relative"
        w="full"
      >
        <Flex
          align="center"
          justify="flex-start"
          left={{ base: 0, md: "1rem" }}
          position="absolute"
          w="full"
        >
          <BackNavArrowCta handleClick={goToPrevious} />
        </Flex>
        <Phase />
      </MaxContentSection>
      <ProgressBar />
    </FullBleedSection>
  );
};
